import React from "react";
import { Link } from "react-router-dom";
import {
  LogoutOutlined,
  FundViewOutlined,
  FileAddOutlined,
  FolderOpenOutlined,
} from "@ant-design/icons";
const Welcome = () => {
  return (
    <div className="welcome-page">
      <div className="welcome-wrap">
        <Link to={"/Dashboard"} className="welcome-item">
          <figure>
            <FileAddOutlined />
          </figure>
          <figcaption>Create Book</figcaption>
        </Link>
        <Link to={"/Mybooks"} className="welcome-item">
          <figure>
            <FolderOpenOutlined />
          </figure>
          <figcaption>My Books</figcaption>
        </Link>
        <Link to={"/"} className="welcome-item">
          <figure>
            <LogoutOutlined />
          </figure>
          <figcaption>Logout</figcaption>
        </Link>
        <Link to={"/Activities"} className="welcome-item">
          <figure>
            <FundViewOutlined />
          </figure>
          <figcaption>Users Activities</figcaption>
        </Link>
      </div>
      <div className="shapes">
        <div className="circle-shape shape-1">
          <svg width="40" height="40" xmlns="http://www.w3.org/2000/svg">
            <circle
              cx="20"
              cy="20"
              r="20"
              fill="#FFD8CD"
              fillRule="evenodd"
            ></circle>
          </svg>
        </div>
        <div className="circle-shape shape-2">
          <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg">
            <circle
              cx="15"
              cy="15"
              r="15"
              fill="#8950E4"
              fillRule="evenodd"
            ></circle>
          </svg>
        </div>
        <div className="circle-shape shape-3">
          <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
            <circle
              cx="10"
              cy="10"
              r="10"
              fill="#33c8c1"
              fillRule="evenodd"
            ></circle>
          </svg>
        </div>
        <div className="circle-shape shape-4">
          <svg width="200" height="200" xmlns="http://www.w3.org/2000/svg">
            <circle
              cx="100"
              cy="100"
              r="100"
              fill="#6c63ff"
              fillRule="evenodd"
            ></circle>
          </svg>
        </div>
        <div className="circle-shape shape-5">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="119.496"
            height="96.771"
            viewBox="0 0 119.496 96.771"
          >
            <g id="Group_173" transform="translate(-1768.066 -254.709)">
              <path
                id="Path_83"
                d="M1614.942,311.638s11.066-20.12,26.156-11.066,21.126-1.006,24.144-13.078,16.1-12.072,27.163-9.054,26.156,1.006,26.156-15.09"
                transform="translate(154 -8.641)"
                fill="none"
                stroke="#6f0298"
                strokeWidth="2"
                opacity="0.55"
              ></path>
              <path
                id="Path_84"
                d="M1614.942,311.638s11.066-20.12,26.156-11.066,21.126-1.006,24.144-13.078,16.1-12.072,27.163-9.054,26.156,1.006,26.156-15.09"
                transform="translate(164 15.359)"
                fill="none"
                stroke="#eba31a"
                strokeWidth="2"
                opacity="0.55"
              ></path>
              <path
                id="Path_85"
                d="M1614.942,311.638s11.066-20.12,26.156-11.066,21.126-1.006,24.144-13.078,16.1-12.072,27.163-9.054,26.156,1.006,26.156-15.09"
                transform="translate(168 39.359)"
                fill="none"
                stroke="#0797e6"
                strokeWidth="2"
                opacity="0.55"
              ></path>
            </g>
          </svg>
        </div>
        <div className="circle-shape shape-6">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="119.496"
            height="96.771"
            viewBox="0 0 119.496 96.771"
          >
            <g id="Group_173" transform="translate(-1768.066 -254.709)">
              <path
                id="Path_83"
                d="M1614.942,311.638s11.066-20.12,26.156-11.066,21.126-1.006,24.144-13.078,16.1-12.072,27.163-9.054,26.156,1.006,26.156-15.09"
                transform="translate(154 -8.641)"
                fill="none"
                stroke="#6f0298"
                strokeWidth="2"
                opacity="0.55"
              ></path>
              <path
                id="Path_84"
                d="M1614.942,311.638s11.066-20.12,26.156-11.066,21.126-1.006,24.144-13.078,16.1-12.072,27.163-9.054,26.156,1.006,26.156-15.09"
                transform="translate(164 15.359)"
                fill="none"
                stroke="#eba31a"
                strokeWidth="2"
                opacity="0.55"
              ></path>
              <path
                id="Path_85"
                d="M1614.942,311.638s11.066-20.12,26.156-11.066,21.126-1.006,24.144-13.078,16.1-12.072,27.163-9.054,26.156,1.006,26.156-15.09"
                transform="translate(168 39.359)"
                fill="none"
                stroke="#0797e6"
                strokeWidth="2"
                opacity="0.55"
              ></path>
            </g>
          </svg>
        </div>
        <div className="circle-shape shape-7">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="119.496"
            height="96.771"
            viewBox="0 0 119.496 96.771"
          >
            <g id="Group_173" transform="translate(-1768.066 -254.709)">
              <path
                id="Path_83"
                d="M1614.942,311.638s11.066-20.12,26.156-11.066,21.126-1.006,24.144-13.078,16.1-12.072,27.163-9.054,26.156,1.006,26.156-15.09"
                transform="translate(154 -8.641)"
                fill="none"
                stroke="#6f0298"
                strokeWidth="2"
                opacity="0.55"
              ></path>
              <path
                id="Path_84"
                d="M1614.942,311.638s11.066-20.12,26.156-11.066,21.126-1.006,24.144-13.078,16.1-12.072,27.163-9.054,26.156,1.006,26.156-15.09"
                transform="translate(164 15.359)"
                fill="none"
                stroke="#eba31a"
                strokeWidth="2"
                opacity="0.55"
              ></path>
              <path
                id="Path_85"
                d="M1614.942,311.638s11.066-20.12,26.156-11.066,21.126-1.006,24.144-13.078,16.1-12.072,27.163-9.054,26.156,1.006,26.156-15.09"
                transform="translate(168 39.359)"
                fill="none"
                stroke="#0797e6"
                strokeWidth="2"
                opacity="0.55"
              ></path>
            </g>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
